<template>
	<div class="title-container">
		<p class="title">
			{{ value }}
		</p>
	</div>
</template>

<script>
	export default {
		name: 'Title',
		props: {
			value: {
				type: String,
				required: true,
			},
		},
	}
</script>

<style lang="scss">
	.title-container {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;

		.title {
			color: var(--titleColor);
			font-size: 2rem;
			font-weight: 700;
			letter-spacing: -0.05em;
			line-height: 1;
			text-align: center;
			text-transform: uppercase;
			margin: 0;
		}
	}
</style>
